import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";

export interface AppsMultiLanguageSettingsUpdateLocaleProps {
  localeId: string;
  a11y_lang?: string;
}

export interface AppsMultiLanguageSettingsUpdateLocaleResult {
  success: boolean;
}

export type MissingLocaleIdError = FetchUserEncodedError<"MISSING_LOCALE_ID">;

export type UpdateNonExistingLocaleError = FetchUserEncodedError<"UPDATE_NON_EXISTING_LOCALE">;

export type InvalidLocaleUpdateError = FetchUserEncodedError<"INVALID_LOCALE_UPDATE">;

export type UpdateLocaleErrors = MissingLocaleIdError | UpdateNonExistingLocaleError | InvalidLocaleUpdateError;

export const isUpdateLocaleError = (error: FetchRequestError): error is UpdateLocaleErrors => {
  return error instanceof FetchUserEncodedError;
};
